export default "__VITE_ASSET__Ch$mowmw__"